import { FC, useState } from 'react';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { FacetFilterProps, Styled } from '.';
import { Checkbox } from 'components/core/Checkbox';
import { ProductAggregationValue } from 'types';

const FacetFilter: FC<FacetFilterProps> = ({
  facetFilter,
  onChange,
  appliedFacetFilters,
  translations,
}) => {
  const [isOpen, setOpen] = useState(true);

  const getTranslatedName = (name: string) => {
    return translations?.[name] || name;
  };

  return (
    <>
      {facetFilter && facetFilter.values?.length > 1 && (
        <>
          <Styled.FilterContainer>
            <Styled.FilterTitle onClick={() => setOpen(open => !open)}>
              <div>{getTranslatedName(facetFilter.name)}</div>
              <div>
                {isOpen ? (
                  <MdKeyboardArrowDown size={'24px'} />
                ) : (
                  <MdKeyboardArrowUp size={'24px'} />
                )}
              </div>
            </Styled.FilterTitle>
            <Styled.Line />
            <Styled.FilterBody>
              {facetFilter.values.map((facet: ProductAggregationValue) => {
                return (
                  <>
                    {isOpen && facet.name?.length > 0 && (
                      <Styled.SubCategoryContainer key={facet.name}>
                        <Styled.SubCategoryItem>
                          <Checkbox
                            label={`${getTranslatedName(facet.name)} (${facet.count})`}
                            checked={
                              typeof appliedFacetFilters.find(
                                item =>
                                  item.filterKey === facetFilter.key &&
                                  item.filterValue === facet.name
                              ) !== 'undefined'
                            }
                            value={facet.name}
                            onChange={event =>
                              onChange(
                                facetFilter.key,
                                facet.name,
                                event.target.checked
                              )
                            }
                          />
                        </Styled.SubCategoryItem>
                      </Styled.SubCategoryContainer>
                    )}
                  </>
                );
              })}
            </Styled.FilterBody>
          </Styled.FilterContainer>
        </>
      )}
    </>
  );
};

export default FacetFilter;
